"use strict";
exports.__esModule = true;
function innerSearch(array, value, lower, pos, upper) {
    if (array[pos].key <= value && value < array[pos + 1].key) {
        return array[pos];
    }
    else if (value < array[pos].key) {
        return innerSearch(array, value, lower, Math.floor((lower + pos - 1) / 2), pos - 1);
    }
    return innerSearch(array, value, pos + 1, Math.floor((pos + 1 + upper) / 2), upper);
}
function binarySearch(array, value) {
    return innerSearch(array, value, 0, Math.floor((array.length - 1) / 2), array.length - 1);
}
exports.binarySearch = binarySearch;
//# sourceMappingURL=binary_search.js.map